import { render, staticRenderFns } from "./APInquiryHistory_V2.vue?vue&type=template&id=4e165a8c&scoped=true&"
import script from "./APInquiryHistory_V2.vue?vue&type=script&lang=js&"
export * from "./APInquiryHistory_V2.vue?vue&type=script&lang=js&"
import style0 from "./APInquiryHistory_V2.vue?vue&type=style&index=0&id=4e165a8c&lang=less&scoped=true&"
import style1 from "./APInquiryHistory_V2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e165a8c",
  null
  
)

component.options.__file = "APInquiryHistory_V2.vue"
export default component.exports